import { FC, useState } from "react";
import { LegacyDesktopFooter } from "../../widgets/footer";
import { LegacyDesktopHeader } from "../../widgets/header";
//import { getStaticUrl } from "../../utils";

import { Menu, MenuButton } from '../../components/Menu';
import { PremiumPartner } from '../PremiumPartner';
import { ShopIcon, TicketIcon, UsersIcon } from '../Icons';
import { BottomMenu } from '../mobile/BottomMenu';

interface LegacyDesktopLayoutProps {
    children?: React.ReactNode;
}

export const LegacyDesktopLayout: FC<LegacyDesktopLayoutProps> = ({
    children,
}) => {
    const bgUrl = ` bg-[url(https://fcrodina.com/static/images/bg/rodina.jpg)]`;
    const bgClass = "bg-fixed" + bgUrl;
    return (
        <div className={bgClass}>
            <LegacyDesktopHeader />
            <div className="w-full bg-white/95" style={{ fontFamily: 'Futura, sans-serif' }}>
                {children}
            </div>
            <LegacyDesktopFooter />
        </div>
    );
}

interface LegacyDesktopLayoutProps {
    children?: React.ReactNode;
}

export const LegacyMobileLayout: FC<LegacyDesktopLayoutProps> = ({
    children,
}) => {
    const [menuOpened, setMenuOpened] = useState(false);
    const bgUrl = ` bg-[url(https://fcrodina.com/static/images/bg/rodina.jpg)]`;
    const bgClass = "bg-fixed" + bgUrl;
    const title = '«РОДИНА»';
    const subtitle = 'Футбольный клуб';
    return (
        <div className={bgClass}>
            <header className="fixed z-50 top-0 left-0 right-0 bg-slate-950 text-white px-4 py-2 flex flex-row gap-3 justify-between items-center">
                <div className="flex flex-row items-center gap-2" style={{
                    fontFamily: 'Futura, sans-serif',
                }}>
                    <img src="https://fcrodina.com/i/logo.png" alt="ФК Родина" className="w-12 h-12" />
                    <div className="flex flex-col items-center justify-center">
                        <div className="text-sm uppercase font-medium">{subtitle}</div>
                        <div className="text-2xl font-bold">{title}</div>
                    </div>
                </div>
                <div className="flex flex-row gap-3">
                    <PremiumPartner />
                    <MenuButton collapsed={!menuOpened} onClick={() => setMenuOpened(!menuOpened)} />
                </div>
            </header>
            <div className="w-full pt-16 max-w-screen overflow-hidden bg-slate-100 /*bg-[url(https://tickets.fcrodina.com/bg.png)]*/" style={{ fontFamily: 'Futura, sans-serif' }}>
                <Menu collapsed={!menuOpened} onItemSelect={(key: string) => setMenuOpened(false)} />
                {children}
            </div>
            <LegacyDesktopFooter />
            <div className="sm:hidden">
                <BottomMenu items={[
                    { title: 'Билеты', href: 'https://tickets.fcrodina.com/', icon: <TicketIcon /> },
                    { title: 'Магазин', href: 'https://shop.fcrodina.com', icon: <ShopIcon /> },
                    { title: 'Родные', href: 'https://my.fcrodina.com', icon: <UsersIcon /> },
                ]} />
            </div>
        </div>
    );
}